import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbc2d0fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preferences" }
const _hoisted_2 = {
  class: "preferences__fields_container",
  "data-test": "preferences-fields"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_range = _resolveComponent("app-range")!
  const _component_app_checkbox = _resolveComponent("app-checkbox")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t("preferences.title")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_app_range, {
        id: "num-of-rounds",
        name: "numberOfRounds",
        min: 1,
        max: 10,
        value: _ctx.numberOfRounds,
        onModify: _ctx.changeHandler
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("preferences.num_of_rounds")), 1)
        ]),
        _: 1
      }, 8, ["value", "onModify"]),
      _createVNode(_component_app_range, {
        id: "breaths-per-round",
        name: "breathsPerRound",
        min: 10,
        max: 60,
        value: _ctx.breathsPerRound,
        onModify: _ctx.changeHandler
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("preferences.breaths_per_round")), 1)
        ]),
        _: 1
      }, 8, ["value", "onModify"]),
      _createVNode(_component_app_range, {
        id: "breath-time",
        name: "breathTime",
        min: 1400,
        max: 2600,
        step: 600,
        value: _ctx.breathTime,
        onModify: _ctx.changeHandler,
        valueTranslation: {
          1400: _ctx.$t('preferences.breathing_pace_fast'),
          2000: _ctx.$t('preferences.breathing_pace_moderate'),
          2600: _ctx.$t('preferences.breathing_pace_slow'),
        }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("preferences.breathing_pace")), 1)
        ]),
        _: 1
      }, 8, ["value", "onModify", "valueTranslation"]),
      _createVNode(_component_app_range, {
        id: "recovery-time",
        name: "recoveryTime",
        min: 5,
        max: 30,
        value: _ctx.recoveryTime,
        onModify: _ctx.changeHandler
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("preferences.recovery_time")), 1)
        ]),
        _: 1
      }, 8, ["value", "onModify"]),
      _createVNode(_component_app_checkbox, {
        id: "disable-animation",
        name: "disableAnimation",
        value: _ctx.disableAnimation,
        onModify: _ctx.changeHandler
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("preferences.disable_animation")), 1)
        ]),
        _: 1
      }, 8, ["value", "onModify"]),
      _createVNode(_component_app_checkbox, {
        id: "disable-start-tips",
        name: "disableStartTips",
        value: _ctx.disableStartTips,
        onModify: _ctx.changeHandler
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("preferences.disable_start_tips")), 1)
        ]),
        _: 1
      }, 8, ["value", "onModify"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_app_button, { onClick: _ctx.restoreDefault }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("preferences.restore_default")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}